import { FC, PropsWithChildren, useRef } from 'react';

import { SwipeContext, SwipeContextProps } from '@hh.ru/magritte-ui-swipe/context';

export const SwipeGroup: FC<PropsWithChildren> = ({ children }) => {
    const closeFuncsRef = useRef<Record<string, VoidFunction>>({});

    const valueRef = useRef<SwipeContextProps>({
        register: (id, closeFunc) => {
            closeFuncsRef.current[id] = closeFunc;
        },
        onShown: (activeId) => {
            Object.entries(closeFuncsRef.current)
                .filter(([id]) => id !== activeId)
                .forEach(([, closeFunc]) => closeFunc());
        },
    });

    return <SwipeContext.Provider value={valueRef.current}>{children}</SwipeContext.Provider>;
};
